import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	sorry: {
		id: 'partner.error',
		defaultMessage: 'Oops! Something went wrong.',
		description: 'Error sorry',
	},
	support: {
		id: 'partner.error.support',
		defaultMessage: 'Please try again or <supportlink>Visit Our Support Page</supportlink>',
		description: 'Error support link',
	},
	errorCode: {
		id: 'partner.error.errorCode',
		defaultMessage: 'Error Code: {error}',
		description: 'Error code text',
	},
	participantId: {
		id: 'partner.error.participantId',
		defaultMessage: 'Participant ID: {pid}',
		description: 'Error participant id',
	},
	partnerNotFound: {
		id: 'partner.error.partnerNotFound',
		defaultMessage:
			'This is not an active signup page. Please check your link and try again. If you continue to receive this error, please reach out to your Benefits Administrator to confirm you have the correct website link.',
		description: "Error message received when accessing a page for a Calm Partner that doesn't exist",
	},
	partnerNotFoundRevamp: {
		id: 'partner.error.revamp.partnerNotFound',
		defaultMessage:
			'This is not an active signup page. Please check your link and try again. If you continue to receive this error, please reach out to your organization to confirm you have the correct website link.',
		description: "Error message received when accessing a page for a Calm Partner that doesn't exist",
	},
	partnerNotActive: {
		id: 'partner.error.partnerNotActive',
		defaultMessage:
			'Access for your group is coming soon! Please reach out to your Benefits Administrator for further information.',
		description: "Error message when trying to access a partner who hasn't started their contract yet.",
	},
	userHasSubscription: {
		id: 'partner.error.userAlreadySubscribed',
		defaultMessage:
			'You already have a Calm Premium subscription, so you can’t activate this offer right now. <managesubscriptionlink>You can learn more about your own subscription here.</managesubscriptionlink>',
		description: 'Error message that shows when a user is trying to redeem when they are already subscribed',
	},
	eligibilityError: {
		id: 'partner.error.eligibilityRedeemError',
		defaultMessage:
			"The activation ID you've entered is not eligible for this offer. Please reach out to your Benefits Administrator to confirm your activation ID. This may be an email address, employee ID, access code, or other identifier.",
		description:
			'Error message for when a Calm Partner tries to redeem a subscription with an id that is not valid',
	},
	invalidToken: {
		id: 'partner.error.invalidToken',
		defaultMessage:
			'Please try following the instructions provided to you by {partnerName} again. If you continue to receive this error, please <supportlink>Visit Our Support Page.</supportlink>',
		description:
			'Error message when the user tries to access the partner signup page without a valid access token.',
	},
	invalidRedeemId: {
		id: 'partner.error.invalidRedeemId',
		defaultMessage:
			"The activation ID you've entered is not eligible for this offer. Please reach out to your Benefits Administrator to confirm your activation ID. This may be an email address, employee ID, access code, or other identifier.",
		description:
			'Error message when the user tries to access the partner signup page without a valid redemption ID.',
	},
	invalidOfferCodeId: {
		id: 'partner.error.invalidOfferCodeId',
		defaultMessage: 'This offer code is not valid or has already been used.',
		description: 'Error message when the user tries to use an invalid offer code embedded link.',
	},
	salesPartnerExceededMaxSubscriptions: {
		id: 'partner.error.salesPartnerExceededMaxSubscriptions',
		defaultMessage:
			"You've reached your maximum number of accounts for your trial, please contact your administrator to request access.",
		description:
			'Error when a user tries to sales trial partner subscription and the partner has already reached their contract covered lives.',
	},
	groupCodePartnerExceededMaxSubscriptionsHeader: {
		id: 'partner.error.groupCodePartnerExceededMaxSubscriptions.header',
		defaultMessage: 'Group Code limit reached',
		description:
			'Error header when a user tries to redeem group code subscription and the partner has already reached their contract covered lives.',
	},
	groupCodePartnerExceededMaxSubscriptions: {
		id: 'partner.error.groupCodePartnerExceededMaxSubscriptions.message',
		defaultMessage:
			'The Group Code you entered has already reached its maximum redemption limit. Please reach out to your HR or benefits administrator for next steps.',
		description:
			'Error when a user tries to redeem group code subscription and the partner has already reached their contract covered lives.',
	},
	ssoMissingTokenMultipleLinks: {
		id: 'partner.error.ssoMissingTokenMultipleLinks',
		defaultMessage:
			'Welcome to Calm! Single Sign On is required for {partnerName}. Please use the links below to redirect to the SSO login page: {links}',
		description:
			'A user can land on the SSO page without the proper SSO credentials, so we present multiple links to redirect to the correct login page',
	},
	ssoMissingTokenFriendly: {
		id: 'partner.error.ssoMissingTokenFriendly',
		defaultMessage:
			'Welcome to Calm! Single Sign On is required for {partnerName}. <anchor>Please click this link to redirect to the SSO login page.</anchor>',
		description:
			'A user can land on the SSO page without the proper SSO credentials, so we redirect to the correct login page',
	},
	ssoMissingToken: {
		id: 'partner.error.ssoMissingToken',
		defaultMessage:
			'Single Sign On is required for {partnerName}. <anchor>Please click this link to redirect to the SSO login page.</anchor>',
		description:
			'A user can land on the SSO page without the proper SSO credentials, so we redirect to the correct login page',
	},
	ssoMissingTokenNoRenewUrl: {
		id: 'partner.error.ssoMissingToken.noRenewUrl',
		defaultMessage:
			'Single Sign On is required for {partnerName}. Please reach out to your Benefits Administrator for further information.',
		description:
			'A user can land on the SSO page without the proper SSO credentials, and in rare cases there is nowhere to take them',
	},
	invalidRedeemIdApi: {
		id: 'partner.error.invalidRedeemIdApi',
		defaultMessage:
			"The link you've followed is not eligible for this offer. Please try following the instructions provided to you by {partnerName} again. If you continue to receive this error, please <supportlink>Visit Our Support Page.</supportlink>",
		description:
			'Error message when the user tries to access the partner signup page without a valid redemption ID for an API partner.',
	},
	alreadyRedeemed: {
		id: 'b2b.error.alreadyRedeemedEligibility',
		defaultMessage:
			'We are sorry, but this link has already been used to redeem a subscription. Please try following the instructions provided to you by {partnerName} again. If you continue to receive this error, please <supportlink>Visit Our Support Page.</supportlink>',
		description: 'User cannot redeem the offer a second time',
	},
	dataSharingRequired: {
		id: 'b2b.error.dataSharingRequired',
		defaultMessage:
			'We are sorry, but you must opt in to the data sharing policy to redeem a subscription. Please try following the instructions provided to you by {partnerName} again. If you continue to receive this error, please <supportlink>Visit Our Support Page.</supportlink>',
		description: 'User must agree to data sharing policy',
	},
	groupCodeMismatch: {
		id: 'b2b.error.groupCodeMismatch',
		defaultMessage: "We don't recognize this code. Please try again.",
		description: 'User enters the wrong group code',
	},
	backButton: {
		id: 'b2b.error.backButton',
		defaultMessage: 'Back',
		description: 'Button to move back in the flow',
	},
});
